import type { ConfigRouteParamsRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-node';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

export type EventParticipantsPathRequestParams = paths['/events/{eventId}/participants']['get']['parameters']['path'];
export type EventParticipantsQueryRequestParams = paths['/events/{eventId}/participants']['get']['parameters']['query'];
type ResponseType = paths['/events/{eventId}/participants']['get']['responses']['200']['content']['application/json'];

export const getEventParticipants = async ({
  config: { params },
  routeParams: { eventId },
}: ConfigRouteParamsRequest<EventParticipantsQueryRequestParams, EventParticipantsPathRequestParams>) =>
  nodeApiClient.get<ResponseType, ApiClientResponse<ResponseType>>(nodeApiRoutes.events.participants.get(eventId), {
    params,
  });
